module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/Temperature/Nagano_Temperature_MRI_RCP85_End.png";